module.exports = __webpack_public_path__ + "img/isPro4_1.15383392.png";